<template>
  <div v-if="settings" class="min-h-screen lg:mr-44">
    <!-- Header -->
    <div
      class="bg-expo_dblue w-full relative z-10 text-white flex flex-col justify-center overflow-y-visible bg-no-repeat bg-center h-[100vh] bg-cover"
      :style="{
        backgroundImage: 'url(' + bgImage + ')',
      }"
    >
      <!--
        <video
        class="absolute object-cover lg:object-fill w-full h-full z-0"
        preload="auto"
        autoplay=""
        playsinline=""
        loop=""
        muted=""
        >
        <source src="/img/expo_video.mp4" type="video/mp4" />
        </video> 
      -->
      <div
        class="flex flex-col gap-12 justify-start items-start pl-12 pr-12 pt-24 lg:pl-32 lg:pr-56 lg:pt-36"
      >
        <div class="text-6xl sm:text-7xl md:text-8xl text-left hero-logo">
          Welcome to<br class="hidden lg:block" />
          the Tahat<span
            :style="{
              'font-family': `'georgiapro'`,
            }"
            >&#363;</span
          ><br class="hidden lg:block" />
          Careers Expo NZ
        </div>

        <img
          src="/img/expo-tahatu-banner-logo2025.svg"
          alt="expo logo"
          class="h-auto w-full sm:w-1/2 z-10 max-w-lg"
        />
      </div>

      <img
        :src="bgImageStarsLeft"
        class="absolute hidden lg:block left-0 top-12 h-1/2 z-10 max-w-none"
      />
      <img
        :src="bgImageStarsRight"
        class="absolute right-0 top-12 h-full z-10 max-w-none"
      />

      <!-- OUT OF SEASON HTML -->
      <!--
        <div class="max-w-3xl flex flex-col text-center z-10 px-12 lg:px-0">
        <h1 class="text-4xl lg:text-5xl text-center">
        Meet the Future of Work
        </h1>
        <p class="font-bold text-base lg:text-lg mb-2">
        We believe that young people are the future.
        </p>
        <p class="text-base mb-24">
        That's why for over 30 years, we've been helping them make the first
        steps in the world of work, by connecting them with the best training
        and employment opportunities Aotearoa has to offer.
        </p>
        </div> 
      -->
      <!-- /OUT OF SEASON HTML -->

      <!-- DURING SEASON HTML -->
      <!--
        <div class="max-w-3xl flex flex-col text-center z-10 px-12 lg:px-0">
        <h1 class="text-2xl lg:text-3xl text-center">
        Meet the Future of Work
        </h1>

        <div
        class="flex flex-col text-center z-10 p-4 rounded-xl lg:mb-24 lg:mt-12"
        :style="{
        background: 'rgba(0,0,0,0.3)',
        }"
        >
        <h3 class="text-xl text-center m-0">Wellington Expo</h3>
        <h4 class="text-lg text-center m-0">Wednesday 26 June</h4>
        <h4 class="text-lg text-center m-0">10am - 3pm, 5pm - 7pm</h4>
        <h4 class="text-lg text-center font-bold mt-6">
        open to everyone and entry is free!
        </h4>

        <h3 class="text-xl text-center m-0">Coming soon</h3>
        <h4 class="text-lg text-center m-0">Wellington</h4>
        <h4 class="text-lg text-center font-bold m-0">View details below</h4>
        </div>
        </div> 
      -->
      <!-- /DURING SEASON HTML -->

      <!--
        <div
        class="absolute bottom-0 transform translate-y-1/2 h-52 flex space-x-2 lg:space-x-8 w-full lg:w-auto px-2 lg:px-0"
        >
        <a
        :class="'bg-no-repeat bg-center bg-cover'"
        :style="{ backgroundImage: 'url(' + bgimage2 + ')' }"
        class="w-1/2 h-auto lg:h-52 lg:w-52 rounded-3xl border-4 border-white text-white hover:text-white flex flex-col justify-center items-center p-2 no-underline hover:no-underline"
        @click="heroRoute('ForExhibitors')"
        >
        <div>
        <span class="text-expo_red text-2xl font-poppins italic font-bold"
        >for</span
        >
        <h2 class="font-light">Exhibitors</h2>
        </div>
        <p class="text-sm font-normal">Book your stand</p>
        </a>

        <a
        :class="'bg-no-repeat bg-center bg-cover'"
        :style="{ backgroundImage: 'url(' + bgimage3 + ')' }"
        class="w-1/2 h-auto lg:h-52 lg:w-52 rounded-3xl border-4 border-white text-white hover:text-white flex flex-col justify-center items-center p-2 no-underline hover:no-underline"
        @click="heroRoute('Schools')"
        >
        <div>
        <span class="text-expo_red text-2xl font-poppins italic font-bold"
        >for</span
        >
        <h2 class="font-light">Schools</h2>
        </div>
        <p class="text-sm font-normal">Register attendance</p>
        </a>

        <a
        :href="settings.cloud_url"
        :class="'bg-no-repeat bg-center bg-cover'"
        :style="{ backgroundImage: 'url(' + bgimage4 + ')' }"
        class="h-52 w-52 relative z-10 overflow-hidden hero-gradient rounded-3xl border-4 border-white bg-expo_dblue text-white hover:text-white hidden lg:flex lg:flex-col justify-center items-center p-2 no-underline hover:no-underline bg-cover"
        >
        <span
        class="relative z-20 text-expo_red text-2xl font-poppins font-bold"
        >Online</span
        >
        <h2 class="relative z-20 font-light">Expo</h2>
        </a>
        </div> 
      -->
    </div>

    <div
      class="flex bg-black items-center text-white relative bg-center lg:bg-top-right bg-no-repeat z-10 mobile-darken"
      :style="{ backgroundImage: 'url(/img/careers-expo-home-1.jpg' }"
    >
      <div
        class="flex w-full max-w-8xl flex-wrap lg:flex-nowrap p-8 py-20 lg:p-24 2xl:px-32 lg:py-24 space-y-16 lg:space-y-0"
      >
        <div class="w-full lg:w-8/12 z-20">
          <h4 class="text-expo_red uppercase text-center lg:text-left">
            Inperson for {{ settings.active_year }}
          </h4>
          <h1 class="text-4xl mb-8 text-center lg:text-left">
            Meet the Future of work
            <span class="italic text-expo_red">in person</span>
          </h1>
          <p
            class="text-2xl italic font-thin font-questrial text-center lg:text-left"
          >
            Our regional expos provide the opportunity to connect face to face
            with young people looking to make key decisions about their future
            career choices.
          </p>
        </div>
      </div>
    </div>

    <!-- EVENTS SECTION -->
    <div
      v-if="events.length > 0"
      class="p-8 py-20 lg:p-24 2xl:px-32 pb-32 m-auto bg-truegray-100"
    >
      <div class="w-full flex flex-col items-center justify-center relative">
        <h2
          class="text-4xl font-light font-questrial mb-12 text-truegray-700 w-full text-center"
        >
          {{ settings.active_year }} Expo dates and details
        </h2>
        <Events />
      </div>
    </div>

    <div
      class="flex bg-black items-center text-white relative bg-center lg:bg-top-right bg-no-repeat z-10 mobile-darken"
      :style="{ backgroundImage: 'url(/img/careers-expo-home-2.jpg' }"
    >
      <div
        class="flex w-full max-w-8xl flex-wrap lg:flex-nowrap p-8 py-20 lg:p-24 2xl:px-32 lg:py-24 space-y-16 lg:space-y-0"
      >
        <div class="w-full lg:w-8/12 z-20">
          <h4 class="text-expo_red uppercase text-center lg:text-left">
            Online for {{ settings.active_year }}
          </h4>
          <h1 class="text-4xl mb-8 text-center lg:text-left">
            Meet the Future of work
            <span class="italic text-expo_red">online</span>
          </h1>
          <p
            class="text-2xl italic font-thin font-questrial text-center lg:text-left"
          >
            Our digital expo is always on. 24/7, 365 days of the year. Meet the
            future of work in your own time and on your own terms.
          </p>
        </div>
      </div>
    </div>

    <!-- Online expo -->
    <div class="flex items-center justify-center">
      <div
        class="flex w-full max-w-8xl flex-wrap lg:flex-nowrap p-8 pt-20 pb-4 lg:p-24 2xl:px-32 lg:py-24 space-y-16 lg:space-y-0"
      >
        <div class="w-full lg:w-6/12 lg:px-4 group">
          <div
            class="transition-all duration-300 ease-in-out h-72 border-4 border-white group-hover:shadow-xl hover:shadow-xl rounded-2xl bg-cover bg-center mb-2 lg:mx-12"
            :style="{ backgroundImage: 'url(/img/careers-expo-online.jpg' }"
          ></div>
        </div>

        <div
          class="w-full lg:w-6/12 space-y-4 lg:pr-8 flex flex-col justify-center"
        >
          <h2 class="text-4xl mb-6 font-normal text-center lg:text-left">
            Check out the Online Expo
          </h2>
          <h5
            v-if="settings.total_tenants"
            class="font-poppins font-normal text-xl mb-6 text-center lg:text-left italic"
          >
            We have
            <span class="text-expo_red"
              >{{ settings.total_tenants }} Exhibitors</span
            >
            who are ready right now to help you find your next step in life.
          </h5>
          <div
            class="flex space-x-4 pt-4 items-center justify-center lg:justify-start"
          >
            <button class="btn btn-expo-dblue" @click="goToOnlineExpo">
              Online Expo
            </button>
            <a
              ref="onlineExpoLink"
              class="hidden"
              :href="settings.cloud_url"
            ></a>

            <button class="btn btn-trans-expo-dblue" @click="goToOnlineMag">
              Online Magazine
            </button>
            <a
              ref="onlineMagLink"
              class="hidden"
              :href="settings.cloud_url + '/exhibitor-latest-news'"
            ></a>
          </div>
        </div>
      </div>
    </div>

    <!-- CAREER EXPO EXHIBITORS SECTION -->
    <div
      class="bg-white h-auto w-full relative justify-center items-center pt-16 pb-28 px-10 lg:px-0 overflow-y-visible max-w-6xl m-auto grid grid-cols-1 lg:grid-cols-2 gap-12"
    >
      <!-- col 1 -->
      <div class="w-full flex flex-col justify-center items-start">
        <div class="flex flex-col space-y-4">
          <p class="text-lg italic">
            Every year our Expos prove to be engaging, informative, and
            interactive events for hundreds of schools and thousands of visitors
            seeking to explore their study and employment options.
          </p>
          <p class="pb-6 lg:pb-0 text-lg italic font-bold">
            Join us at any or all of our 7 venues across New Zealand and find
            out exactly what the future of work looks like in
            {{ settings.active_year }}.
          </p>
        </div>
      </div>

      <!-- col 2 -->
      <div
        id="videoBlock"
        class="w-full flex flex-col justify-center items-center"
      >
        <div
          class="relative video-placeholder w-full max-w-xl h-96 z-10 flex justify-center items-center text-white bg-expo_dblue cursor-pointer bg-no-repeat bg-cover bg-center"
          :style="{ backgroundImage: 'url(/img/careers-expo-15.png' }"
          @click="toggleVideo"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-32 w-32 hover:opacity-100 opacity-75 cursor-pointer"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              fill-rule="evenodd"
              d="M10 18a8 8 0 100-16 8 8 0 000 16zM9.555 7.168A1 1 0 008 8v4a1 1 0 001.555.832l3-2a1 1 0 000-1.664l-3-2z"
              clip-rule="evenodd"
            />
          </svg>
        </div>
      </div>
    </div>

    <!-- NEWS REPORT SECTION -->
    <ResourcePanel
      :heading="'News &amp; Updates'"
      :feature="'homepage'"
      :paginate="24"
    />

    <!-- Video Modal -->
    <div
      v-show="videoModal"
      id="videoModal"
      class="fixed z-50 inset-0 overflow-y-auto"
      aria-labelledby="modal-title"
      role="dialog"
      aria-modal="true"
    >
      <div
        class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0"
      >
        <div
          class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
          aria-hidden="true"
        ></div>
        <!-- This element is to trick the browser into centering the modal contents. -->
        <span
          class="hidden sm:inline-block sm:align-middle sm:h-screen"
          aria-hidden="true"
          >&#8203;</span
        >
        <!-- Modal panel, show/hide based on modal state. -->
        <div
          style="height: calc(100vh - 10rem)"
          :class="videoModal ? '' : 'p-8 w-52 h-52'"
          class="bg-cover inline-block align-bottom bg-white border-8 border-white rounded-4xl p-6 text-left shadow transform transition-all duration-300 ease-in-out sm:my-8 sm:align-middle sm:max-w-4xl sm:max-h-lg w-full sm:p-16 relative top-12"
        >
          <div
            class="flex flex-col bg-black absolute bg-center inset-0 w-full h-full rounded-4xl overflow-hidden z-10 bg-no-repeat"
          >
            <iframe
              v-if="videoModal"
              ref="resourceVideoPreview"
              type="iframe"
              class="object-fill w-full h-full"
              :src="videoSrc"
              frameborder="0"
              controls="0"
              pip="0"
              title="1"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
              autoplay
            ></iframe>
          </div>
          <div class="flex flex-col space-y-4">
            <button
              type="button"
              class="absolute z-40 right-16 top-12 transform hover:rotate-180 transition-all duration-300 text-white hover:text-expo_red"
              @click="videoModal = false"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- modal -->
  </div>
</template>

<script>
import { shared } from '../../../js/mixins/shared.js'
import { fileHandling } from '../../../js/mixins/fileHandling.js'
import Events from '../components/EventsPanel.vue'
import ResourcePanel from '../components/ResourcePanel.vue'
import { mapActions, mapGetters } from 'vuex'

window.FileSaver = require('file-saver')

export default {
  components: {
    Events,
    ResourcePanel,
  },

  mixins: [shared, fileHandling],

  data() {
    return {
      bgImage: '/img/expo-banner2025.png',
      bgImageStarsLeft: '/img/expo-banner2025-stars-left.png',
      bgImageStarsRight: '/img/expo-banner2025-stars-right.png',
      bgimage2: '/img/expo-for-exhibitors.png',
      bgimage3: '/img/expo-for-schools.png',
      bgimage4: '/img/careers-expo-exhibitors.jpg',
      info: 'online',
      videoModal: false,
      videoSrc: 'https://www.youtube.com/embed/5oEw5jUb1FU',
    }
  },

  computed: {
    ...mapGetters({
      settings: 'shared/getSettings',
      events: 'expo/getEvents',
    }),
  },

  watch: {
    videoModal: {
      handler: function (val) {
        this.setBodyLockModal(val ? true : false) // Add to all modals to lock the background scroll.
      },

      deep: true,
    },
  },

  async mounted() {
    if (this.events.length < 1) {
      await this.dispatchSetEvents()
    }
  },

  methods: {
    ...mapActions({
      dispatchSetEvents: 'expo/dispatchSetEvents',
    }),

    // goToOrDownloadResource(item) {

    //   if (item.file && item.type === 1) {

    //     this.downloadPdfFromEndpoint('/api/download-resource-pdf/'+item.id);

    //   } else {

    //     let cloud_url = this.settings.cloud_url;
    //     if (cloud_url) {
    //       window.location.href = cloud_url + '/magazine/' + item.id;
    //     }

    //   }

    // },

    toggleVideo() {
      window.scrollBy(0, -300)
      this.videoModal = !this.videoModal
    },

    heroRoute(route) {
      this.$router.push({ name: route })
    },

    goToOnlineExpo() {
      this.$refs.onlineExpoLink.click()
    },

    goToOnlineMag() {
      this.$refs.onlineMagLink.click()
    },

    register(type) {
      if (type === 'exhibitor') {
        this.$router.push({ name: 'ExhibitorRegistration' })
      } else {
        this.$router.push({ name: 'SchoolRegistration' })
      }
    },
  },
}
</script>

<style scoped>
.hero-logo {
  font-family: 'georgiapro', sans-serif;
  font-weight: 900;
  font-style: normal;
}

.hero-gradient::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1;
  height: 100%;
  background: #05162e;
  opacity: 80%;
}

.video-placeholder::before {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  content: '';
  background: linear-gradient(
      223.93deg,
      #fe4a49 8.36%,
      rgba(254, 74, 73, 0.2) 65.47%
    ),
    #05162e;
  z-index: -1;
  opacity: 0.4;
}

@media screen and (max-width: 1024px) {
  .mobile-darken::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: #000;
    opacity: 0.7;
  }
}
</style>
